import React, {Fragment, useEffect, useState} from 'react'
import './WorkPathMap.css'
import IncidentCard from "../incident/IncidentCard";
import {GoogleMap, Marker, Polyline, useJsApiLoader} from "@react-google-maps/api";
import orange_point from "../../images/orange_point.svg";
import red_point from "../../images/red_point.svg";
import {Constants} from "../../Constants";

function WorkPathMap() {
    const [startingData] = useState([
        {
            name: 'Karen Chilton',
            id: 1,
            image: 'red_point.svg',
            image_raw: 'red_point.svg',
            loc: {x: 70, y: '-20'},
            label: 'Welding Area, Zone 1',
            team: 'Team 1',
            designation: 'WID#2144125 | Field Engg.',
            work_type: 'Material Transport',
            machine: 'Forklift 1'
        },
    ]);
    const [alertData] = useState([
        {
            name: 'Missing Helmet',
            id: 1,
            image: 'red_point.svg',
            capture_image: 'Missing Helmet1.png',
            capture_video: 'Missing Safety Helmet1.mp4',
            loc: {x: '52', y: '-202'},
            label: 'Tower 3, Zone 1',
            operator: 'Karen Chilton',
            work_type: 'Blasting',
            alert_type_level: 'Safety Infraction | Severity Level - 1 | Cam#DID1',
            alert_date_time: '25-02-2025 | 09:00 AM',
        },
    ]);
    const [workerData] = useState([
        {
            name: 'Karen Chilton',
            id: 1,
            image: 'Peter Bishops.svg',
            image_raw: 'pt_bishop.svg',
            loc: {x: 70, y: '-20'},
            label: 'Welding Area, Zone 1',
            team: 'Team 1',
            designation: 'WID#2144125 | Field Engg.',
            work_type: 'Material Transport',
            machine: 'Forklift 1'
        },
    ]);

    const [activeIncident, setActiveIncident] = React.useState();


    const [showIncidentDetail, setShowIncidentDetail] = React.useState(false);
    const handleInfoIconClick = (e) => {
        //todo
        setShowIncidentDetail(true);
    }
    const handleDetailCardClose = () => {
        setShowIncidentDetail(false);
    }

    useEffect(() => {
        const el = document.getElementsByClassName('wp-container')[0];
        const observer = new window.IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                return
            }
            setShowIncidentDetail(false);
        }, {
            root: null,
            threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
        })

        observer.observe(el);

    }, []);

    const [center] = useState({
        lat: 37.7687885,
        lng: -117.5698607,
    });

    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: Constants.MAP_API_KEY,
    })

    const [, setMap] = React.useState(null)
    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center)
        if (!map) {
            map.fitBounds(bounds)
            setMap(map)
        }
    }, [center])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const [containerStyle] = useState({
        width: 'auto',
        height: '400px',
    });

    const generateSnakePath = () => {
        const path = [];
        const startLng = -117.5698607;
        const endLng = -117.5510207;
        const numPoints = 30; // Number of points in the snake path
        const deltaLng = (endLng - startLng) / numPoints;

        // Generate points using a sine wave pattern for "snakiness"
        for (let i = 0; i <= numPoints; i++) {
            const lng = startLng + i * deltaLng; // Gradually increase the longitude
            const offset = Math.sin(i * 0.4) * 0.003; // Sin wave for the snake effect (adjust frequency and amplitude)
            const lat = 37.7687885 + offset; // Keep latitude constant, but apply a sine wave to create a wavy effect

            path.push({lat, lng});
        }

        return path;
    };
    return (
        <>
            {showIncidentDetail &&
                <IncidentCard activeIncident={activeIncident} handleDetailCardClose={handleDetailCardClose}
                              handleParentClose={handleDetailCardClose}/>}
            <div className='wp-container'>
                {isLoaded && <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={12}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    {/* Child components, such as markers, info windows, etc. */}
                    <>
                        {startingData.map((starting, key) =>
                            <Fragment key={key}>
                                {/* Add a polyline */}
                                <Polyline
                                    path={generateSnakePath()} // The path for your polyline
                                    options={{
                                        strokeColor: "#F08144", // Red color for the path
                                        // strokeOpacity: 0,
                                        // strokeWeight: 3,
                                        // icons: [
                                        //     {
                                        //         icon: {
                                        //             path: window.google.maps.SymbolPath.LINE, // Use window.google
                                        //             strokeOpacity: 1,
                                        //             strokeWeight: 3,
                                        //             scale: 2, // Adjust scale for visibility
                                        //         },
                                        //         offset: "0",
                                        //         repeat: "10px", // Spacing between dashes
                                        //     },
                                        // ],
                                        // geodesic: false,
                                        strokeOpacity: 0, // Hide the main stroke
                                        strokeWeight: 3,
                                        icons: [
                                            {
                                                icon: {
                                                    path: "M 0,-1 0,1", // This defines a dashed pattern
                                                    strokeOpacity: 1,
                                                    strokeWeight: 3,
                                                    scale: 3,
                                                },
                                                offset: "0",
                                                repeat: "10px", // Controls the dash spacing
                                            },
                                        ],
                                        geodesic: false,
                                    }}
                                />
                                <Marker icon={orange_point}
                                        position={{
                                            lat: 37.7686885,
                                            lng: -117.5698607
                                        }}
                                        onClick={(e) => {
                                            handleInfoIconClick(e);
                                            // setActiveIncident(starting)
                                            if (showIncidentDetail) {
                                                setShowIncidentDetail(!setShowIncidentDetail);
                                            }
                                        }}
                                />)
                            </Fragment>
                        )}
                        {alertData.map((alert, key) =>
                            <Fragment key={key}>
                                <Marker icon={red_point}
                                        position={{
                                            // lat: 37.7687885,
                                            // lng: -117.5698607
                                            lat: 37.7673885, lng: -117.5643607
                                        }}
                                        onClick={(e) => {
                                            handleInfoIconClick(e);
                                            setActiveIncident(alert);
                                            console.debug('')
                                            setShowIncidentDetail(!showIncidentDetail);
                                        }}
                                />)
                            </Fragment>
                        )}
                        {workerData.map((worker, key) =>
                            <Fragment key={key}>
                                <Marker icon={require(`../../images/${worker.image}`)}
                                        position={{
                                            lat: 37.7667885,
                                            lng: -117.5510207
                                        }}
                                    // onClick={(e) => handleWorkerCard(e, worker)}
                                />
                            </Fragment>
                        )}
                        <Marker icon={orange_point}
                                position={{
                                    lat: 37.7667885,
                                    lng: -117.5510207
                                }}
                            // onClick={(e) => handleWorkerCard(e, worker)}
                        />
                    </>
                </GoogleMap>}
            </div>
        </>
    )
}

export default WorkPathMap
